import OBase from './OBase';
import * as Geometry from '../geometry';

import * as GHMath from '../../math';
export default class ESrfSrfIntersect extends OBase {
  update () {
    let surfacePathATree = this.getSurfaceObjectInput('A');
    let surfacePathBTree = this.getSurfaceObjectInput('B');

    let output = this.getGenericObjectOutput('P');
    let dataTrees = [surfacePathATree, surfacePathBTree];
    let outDataTrees = [];

    let outTree = new Geometry.DataTree();
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let a = outDataTrees[0].branches[i][j].map(path => {
          let segments = [];
          for (let k = 0, l = path.length; k < l; k++) {
            let p0 = path[k];
            let p1 = path[(k + 1) % l];
            segments.push(new GHMath.GHSegment(p0.X, p0.Y, p1.X, p1.Y));
          }
          return segments;
        });

        let b = outDataTrees[1].branches[i][j].map(path => {
          let segments = [];
          for (let k = 0, l = path.length; k < l; k++) {
            let p0 = path[k];
            let p1 = path[(k + 1) % l];
            segments.push(new GHMath.GHSegment(p0.X, p0.Y, p1.X, p1.Y));
          }
          return segments;
        });

        let points = [];

        a.forEach(aSegments => {
          aSegments.forEach(aseg => {
            b.forEach(bSegments => {
              bSegments.forEach(bseg => {
                let ret = aseg.getSegmentIntersectionPoint(bseg);
                if (ret.result) {
                  // Check if a duplicated point exists caused by calculation error.
                  // MEMO:
                  //  in Grasshopper side, ESrfSrfIntersect checks intersection by parametric curve.
                  //  but in WebGL side, there is a possibility for duplicated points because of checking intersection by polyline
                  let duplicated = points.find(p => {
                    let dx = Math.abs(p.x - ret.point.x);
                    let dy = Math.abs(p.y - ret.point.y);
                    // return dx + dy <= Number.EPSILON
                    return dx + dy <= 1e-12;
                  });
                  if (duplicated === undefined) {
                    points.push(new THREE.Vector3(ret.point.x, ret.point.y, 0));
                  }
                }
              });
            });
          });
        });

        points.forEach(p => {
          outTree.add(p, outDataTrees[0].paths[i]);
        });
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ESrfSrfIntersect.js